import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { AddressFieldsProps } from './types';
import useRequiredComponent from './useRequiredComponent';
import FormInput from '@/form/FormInput';
function CityField(t0) {
  const $ = _c(5);
  const {
    required
  } = t0;
  const t = useTranslations("nextjs.donate.attributes");
  const FieldComponent = useRequiredComponent(required);
  let t1;
  if ($[0] !== t) {
    t1 = t("city");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const label = t1;
  let t2;
  if ($[2] !== FieldComponent || $[3] !== label) {
    t2 = <FieldComponent name="city" title={label} as={FormInput} />;
    $[2] = FieldComponent;
    $[3] = label;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export default CityField;